var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconTrailer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 15,
    viewBox: "0 0 20 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "wifi",
    d: "M1.05424 0.24707H18.6814C19.2016 0.24707 19.6607 0.706111 19.6607 1.22636C19.6607 1.7772 19.2016 2.20564 18.6814 2.20564V11.9985C19.2016 11.9985 19.6607 12.4575 19.6607 12.9778C19.6607 13.5286 19.2016 13.9571 18.6814 13.9571H1.05424C0.503389 13.9571 0.0749512 13.5286 0.0749512 12.9778C0.0749512 12.4575 0.503389 11.9985 1.05424 11.9985V2.20564C0.503389 2.20564 0.0749512 1.7772 0.0749512 1.22636C0.0749512 0.706111 0.503389 0.24707 1.05424 0.24707ZM5.46102 3.91939C5.46102 3.52156 5.12439 3.18493 4.72656 3.18493C4.29812 3.18493 3.99209 3.52156 3.99209 3.91939V10.2848C3.99209 10.7132 4.29812 11.0192 4.72656 11.0192C5.12439 11.0192 5.46102 10.7132 5.46102 10.2848V3.91939ZM8.88852 3.91939C8.88852 3.52156 8.5519 3.18493 8.15406 3.18493C7.72562 3.18493 7.4196 3.52156 7.4196 3.91939V10.2848C7.4196 10.7132 7.72562 11.0192 8.15406 11.0192C8.5519 11.0192 8.88852 10.7132 8.88852 10.2848V3.91939ZM12.316 3.91939C12.316 3.52156 11.9794 3.18493 11.5816 3.18493C11.1531 3.18493 10.8471 3.52156 10.8471 3.91939V10.2848C10.8471 10.7132 11.1531 11.0192 11.5816 11.0192C11.9794 11.0192 12.316 10.7132 12.316 10.2848V3.91939ZM15.7435 3.91939C15.7435 3.52156 15.4069 3.18493 15.0091 3.18493C14.5806 3.18493 14.2746 3.52156 14.2746 3.91939V10.2848C14.2746 10.7132 14.5806 11.0192 15.0091 11.0192C15.4069 11.0192 15.7435 10.7132 15.7435 10.2848V3.91939Z",
    fill: "#E6E8F0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "wifi_2",
    d: "M18.9451 0.125H1.05447C0.461251 0.125 -0.000143102 0.619351 -0.000143102 1.17962C-0.000143102 1.77284 0.461251 2.23423 1.05447 2.23423H18.9451C19.5054 2.23423 19.9998 1.77284 19.9998 1.17962C19.9998 0.619351 19.5054 0.125 18.9451 0.125Z",
    fill: "url(#paint0_linear_3512_3160)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "wifi_3",
    d: "M18.9451 12.0967H1.05447C0.461251 12.0967 -0.000143102 12.591 -0.000143102 13.1513C-0.000143102 13.7445 0.461251 14.2059 1.05447 14.2059H18.9451C19.5054 14.2059 19.9998 13.7445 19.9998 13.1513C19.9998 12.591 19.5054 12.0967 18.9451 12.0967Z",
    fill: "url(#paint1_linear_3512_3160)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3512_3160",
    x1: -0.000244141,
    y1: 0.335923,
    x2: 0.384993,
    y2: 3.88136,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#990219"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3677D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3512_3160",
    x1: -0.000244141,
    y1: 12.3076,
    x2: 0.384993,
    y2: 15.853,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#990219"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3677D"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTrailer);
export default __webpack_public_path__ + "static/media/icon-trailer.b2234525fe277ffde5c2235c1f1aefd8.svg";
export { ForwardRef as ReactComponent };